import { useCallback } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";
import isCollectionRequest from "../../utils/isCollectionRequest";
import { useRouter } from "@lib/router";

type TLoadOffersReturn = {
  loadOffers: (promoCode?: string) => void;
};

// Hook provides function to explicitly load new offers with optional explicitly set promo code

const useLoadOffers = (): TLoadOffersReturn => {
  const { values } = useOrderFormik();

  const { updateOffers } = useOrderData();

  const countryFrom = values[OrderFields.STARTING_COUNTRY] || undefined;
  const countryTo = values[OrderFields.DESTINATION_COUNTRY] || undefined;
  const deliveryMethod = values[OrderFields.DELIVERY_METHOD] || undefined;
  const packageSizeTitle = values[OrderFields.PACKAGE_SIZE] || undefined;
  const receiverZipCode = values[OrderFields.RECEIVER_ZIP_CODE] || undefined;
  const affiliateId = values[OrderFields.AFFILIATE_ID] || undefined;
  const shipmentId = values[OrderFields.SHIPMENT_ID] || undefined;
  const senderPhoneNumber = values[OrderFields.SENDER_PHONE_NUMBER] || undefined;
  const senderEmail = values[OrderFields.SENDER_EMAIL] || undefined;
  const offerGroupId = values[OrderFields.OFFER_GROUP_ID] || undefined;
  const printLabelType = values[OrderFields.LABEL_PRINT] || undefined;

  const { defaultLocale } = useRouter();

  const useCr = isCollectionRequest(defaultLocale, deliveryMethod, printLabelType);

  const loadOffers = useCallback(
    (promoCode?: string) => {
      updateOffers({
        countryFrom,
        countryTo,
        deliveryMethod,
        packageSizeTitle,
        promoCode,
        receiverZipCode,
        affiliateId,
        shipmentId,
        senderPhoneNumber,
        senderEmail,
        offerGroupId,
        useCr
      });
    },
    [
      affiliateId,
      countryFrom,
      countryTo,
      deliveryMethod,
      packageSizeTitle,
      receiverZipCode,
      senderEmail,
      senderPhoneNumber,
      shipmentId,
      updateOffers,
      offerGroupId,
      useCr
    ]
  );

  return { loadOffers };
};
export default useLoadOffers;
